// import React, { useEffect, useState } from "react";
// import Button from "./Button";
// import { classNames } from "../../helpers/classNames";

// const DragDropfile = ({
//   label,
//   isMultiple = false,
//   labelClasses,
//   value,
//   handleFile = () => {},
//   formats = ".pdf, .jpg, .png, .jpeg, .webp, .csv, .doc, .docx, .gif, .bmp, .webm, .mp4",
//   previewClasses,
//   title = "Drag & Drop files here",
// }) => {
//   const [files, setFiles] = useState([]);
//   const [message, setMessage] = useState("");

//   const allowedTypes = formats
//     .split(",")
//     .map((f) => f.trim().replace(".", ""))
//     .map((ext) => {
//       switch (ext) {
//         case "jpg":
//         case "jpeg":
//           return "image/jpeg";
//         case "png":
//           return "image/png";
//         case "gif":
//           return "image/gif";
//         case "webp":
//           return "image/webp";
//         case "bmp":
//           return "image/bmp";
//         case "pdf":
//           return "application/pdf";
//         case "csv":
//           return "text/csv";
//         case "doc":
//           return "application/msword";
//         case "docx":
//           return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
//         case "webm":
//           return "video/webm";
//         case "mp4":
//           return "video/mp4";
//         default:
//           return "";
//       }
//     });

//   const handleFileChange = (e) => {
//     setMessage("");
//     const selectedFiles = Array.from(e.target.files);
//     const validFiles = [];
//     let error = "";

//     selectedFiles.forEach((file) => {
//       if (allowedTypes.includes(file.type)) {
//         validFiles.push(file);
//       } else {
//         error = "Unsupported file type selected";
//       }
//     });

//     if (validFiles.length > 0) {
//       setFiles((prev) => (isMultiple ? [...prev, ...validFiles] : validFiles));
//     }

//     if (error) setMessage(error);
//     e.target.value = null;
//   };

//   useEffect(() => {
//     if (files.length) {
//       handleFile(files);
//     }
//   }, [files]);

//   useEffect(() => {
//     if (value) {
//       setFiles([value]);
//     }
//   }, [value]);

//   const removeFile = (fileName) => {
//     setFiles((prev) => prev.filter((file) => file.name !== fileName));
//   };

//   return (
//     <div className="flex flex-col w-full gap-2">
//       <div className="w-full relative space-y-1">
//         {label && (
//           <div
//             className={classNames(
//               "text-xs font-medium text-text-disabled mb-1 font-CanelaDeck",
//               labelClasses
//             )}
//           >
//             {label}
//           </div>
//         )}
//         {(isMultiple || files.length === 0) && (
//           <div className="h-80 w-full relative border-2 items-center rounded-md cursor-pointer border-text-secondary/50 border-dashed">
//             <input
//               type="file"
//               onChange={handleFileChange}
//               className="h-full w-full opacity-0 z-10 absolute cursor-pointer"
//               multiple={isMultiple}
//               name="files[]"
//               accept={formats}
//             />
//             <div className="h-full w-full absolute z-1 flex justify-center items-center top-0">
//               <div className="flex flex-col space-y-1 text-center">
//                 <div className="text-primary text-5xl">
//                   <i className="fa-thin fa-cloud-arrow-up"></i>
//                 </div>
//                 <div className="text-lg font-bold text-deep-purple">
//                   {title}
//                 </div>
//                 <div className="text-sm text-slate-400 font-medium">
//                   Supported formats: {formats}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {message && (
//         <div className="text-xs text-red-600 text-center">{message}</div>
//       )}

//       {files.length > 0 && (
//         <div className="flex flex-wrap gap-2 mt-2">
//           {files.map((file, index) => (
//             <div
//               key={index}
//               className={classNames(
//                 "relative w-20 h-20 rounded-md border border-opplio-border flex group",
//                 previewClasses
//               )}
//             >
//               <div className="opacity-0 invisible transition-all duration-200 group-hover:opacity-100 group-hover:visible">
//                 <Button
//                   buttonIcon={"fa-light fa-xmark"}
//                   buttonIconPosition={"left"}
//                   buttonClasses={
//                     "!absolute !w-5 !h-5 !p-0 !justify-center -top-1 -right-1 !text-xs !bg-primary !border-none"
//                   }
//                   buttonFunction={() => removeFile(file.name)}
//                 />
//               </div>
//               <div className="w-full h-full overflow-hidden rounded-md">
//                 {file.type.startsWith("image/") ? (
//                   <img
//                     src={URL.createObjectURL(file)}
//                     alt={file.name}
//                     className="h-full w-full object-cover"
//                   />
//                 ) : file.type.startsWith("video/") ? (
//                   <video
//                     src={URL.createObjectURL(file)}
//                     controls
//                     className="h-full w-full object-cover"
//                   />
//                 ) : (
//                   <iframe
//                     title={file.name}
//                     className="h-full w-full object-cover"
//                     src={URL.createObjectURL(file)}
//                   />
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default DragDropfile;

// import React, { useEffect, useState } from "react";
// import Button from "./Button";
// import { classNames } from "../../helpers/classNames";

// const DragDropfile = ({
//   label,
//   isMultiple = false,
//   labelClasses,
//   value,
//   handleFile = () => {},
//   formats = ".pdf, .jpg, .png, .jpeg, .webp, .csv, .doc, .docx, .gif, .bmp, .webm, .mp4",
//   previewClasses,
//   title = "Drag & Drop files here",
// }) => {
//   const [files, setFiles] = useState([]);
//   const [message, setMessage] = useState("");

//   const allowedTypes = formats
//     .split(",")
//     .map((f) => f.trim().replace(".", ""))
//     .map((ext) => {
//       switch (ext) {
//         case "jpg":
//         case "jpeg":
//           return "image/jpeg";
//         case "png":
//           return "image/png";
//         case "gif":
//           return "image/gif";
//         case "webp":
//           return "image/webp";
//         case "bmp":
//           return "image/bmp";
//         case "pdf":
//           return "application/pdf";
//         case "csv":
//           return "text/csv";
//         case "doc":
//           return "application/msword";
//         case "docx":
//           return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
//         case "webm":
//           return "video/webm";
//         case "mp4":
//           return "video/mp4";
//         default:
//           return "";
//       }
//     });

//   const handleFileChange = (e) => {
//     setMessage("");
//     const selectedFiles = Array.from(e.target.files);
//     const validFiles = [];
//     let error = "";

//     selectedFiles.forEach((file) => {
//       if (allowedTypes.includes(file.type)) {
//         validFiles.push(file);
//       } else {
//         error = "Unsupported file type selected";
//       }
//     });

//     if (validFiles.length > 0) {
//       setFiles((prev) => (isMultiple ? [...prev, ...validFiles] : validFiles));
//     }

//     if (error) setMessage(error);
//     e.target.value = null;
//   };

//   useEffect(() => {
//     if (files.length) {
//       handleFile(files);
//     }
//   }, [files]);

//   useEffect(() => {
//     if (value) {
//       setFiles([value]);
//     }
//   }, [value]);

//   const removeFile = (fileName) => {
//     setFiles((prev) => prev.filter((file) => file.name !== fileName));
//   };

//   return (
//     <div className="flex flex-col w-full gap-2">
//       <div className="w-full relative space-y-1">
//         {label && (
//           <div
//             className={classNames(
//               "text-xs font-medium text-text-disabled mb-1 font-CanelaDeck",
//               labelClasses
//             )}
//           >
//             {label}
//           </div>
//         )}
//         {(isMultiple || files.length === 0) && (
//           <div className="h-80 w-full relative border-2 items-center rounded-md cursor-pointer border-text-secondary/50 border-dashed">
//             <input
//               type="file"
//               onChange={handleFileChange}
//               className="h-full w-full opacity-0 z-10 absolute cursor-pointer"
//               multiple={isMultiple}
//               name="files[]"
//               accept={formats}
//             />
//             <div className="h-full w-full absolute z-1 flex justify-center items-center top-0">
//               <div className="flex flex-col space-y-1 text-center">
//                 <div className="text-primary text-5xl">
//                   <i className="fa-thin fa-cloud-arrow-up"></i>
//                 </div>
//                 <div className="text-lg font-bold text-deep-purple">
//                   {title}
//                 </div>
//                 <div className="text-sm text-slate-400 font-medium">
//                   Supported formats: {formats}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {message && (
//         <div className="text-xs text-red-600 text-center">{message}</div>
//       )}

//       {files.length > 0 && (
//         <div className="flex flex-wrap gap-2 mt-2">
//           {files.map((file, index) => (
//             <div
//               key={index}
//               className={classNames(
//                 "relative w-20 h-20 rounded-md border border-opplio-border flex group",
//                 previewClasses
//               )}
//             >
//               <div className="opacity-0 invisible transition-all duration-200 group-hover:opacity-100 group-hover:visible">
//                 <Button
//                   buttonIcon={"fa-light fa-xmark"}
//                   buttonIconPosition={"left"}
//                   buttonClasses={
//                     "!absolute !w-5 !h-5 !p-0 !justify-center -top-1 -right-1 !text-xs !bg-primary !border-none"
//                   }
//                   buttonFunction={() => removeFile(file.name)}
//                 />
//               </div>
//               <div className="w-full h-full overflow-hidden rounded-md">
//                 {file.type.startsWith("image/") ? (
//                   <img
//                     src={URL.createObjectURL(file)}
//                     alt={file.name}
//                     className="h-full w-full object-cover"
//                   />
//                 ) : file.type.startsWith("video/") ? (
//                   <video
//                     src={URL.createObjectURL(file)}
//                     controls
//                     className="h-full w-full object-cover"
//                   />
//                 ) : (
//                   <iframe
//                     title={file.name}
//                     className="h-full w-full object-cover"
//                     src={URL.createObjectURL(file)}
//                   />
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default DragDropfile;

import React, { useEffect, useState } from "react";
import Button from "./Button";
import { classNames } from "../../helpers/classNames";
import DeleteModal from "../common/DeleteModal";

const DragDropfile = ({
  label,
  isMultiple = false,
  labelClasses,
  value,
  handleFile = () => {},
  onRemove = () => {},
  formats = ".pdf, .jpg, .png, .jpeg, .webp, .csv, .doc, .docx, .gif, .bmp, .webm, .mp4",
  previewClasses,
  title = "Drag & Drop files here",
  removeButton = true,
}) => {
  const [files, setFiles] = useState([]);
  const [message, setMessage] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const allowedTypes = formats
    .split(",")
    .map((f) => f.trim().replace(".", ""))
    .map((ext) => {
      switch (ext) {
        case "jpg":
        case "jpeg":
          return "image/jpeg";
        case "png":
          return "image/png";
        case "gif":
          return "image/gif";
        case "webp":
          return "image/webp";
        case "bmp":
          return "image/bmp";
        case "pdf":
          return "application/pdf";
        case "csv":
          return "text/csv";
        case "doc":
          return "application/msword";
        case "docx":
          return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        case "webm":
          return "video/webm";
        case "mp4":
          return "video/mp4";
        default:
          return "";
      }
    });

  const handleFileChange = (e) => {
    setMessage("");
    const selectedFiles = Array.from(e.target.files);
    const validFiles = [];
    let error = "";

    selectedFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push(file);
      } else {
        error = "Unsupported file type selected";
      }
    });

    if (validFiles.length > 0) {
      setFiles((prev) => (isMultiple ? [...prev, ...validFiles] : validFiles));
    }

    if (error) setMessage(error);
    e.target.value = null;
  };

  useEffect(() => {
    if (files.length) {
      handleFile(files);
    }
  }, [files]);

  useEffect(() => {
    if (value) {
      const normalized = Array.isArray(value) ? value : [value];
      setFiles(normalized);
    }
  }, [value]);

  const removeFile = (fileToRemove) => {
    setFiles((prev) => {
      prev = prev.filter((file) => {
        const fileName = typeof file === "string" ? file : file.name;
        return (
          fileName !==
          (typeof fileToRemove === "string" ? fileToRemove : fileToRemove.name)
        );
      });
      return [...prev];
    });
    onRemove(fileToRemove);
  };

  const getFileURL = (file) => {
    return file instanceof File ? URL.createObjectURL(file) : file?.url || file;
  };

  const getFileType = (file) => {
    if (typeof file === "string") {
      const ext = file.split(".").pop().toLowerCase();
      if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(ext))
        return "image";
      if (["mp4", "webm"].includes(ext)) return "video";
      return "document";
    }

    const fileType = file?.type || "";

    if (fileType.startsWith("image/") || fileType.startsWith("image"))
      return "image";
    if (fileType.startsWith("video/") || fileType.startsWith("video"))
      return "video";
    return "document";
  };
  const confirmDelete = () => {
    setFiles((prev) =>
      prev.filter((f) => {
        const fileName = typeof f === "string" ? f : f.name;
        const deleteName =
          typeof fileToDelete === "string" ? fileToDelete : fileToDelete.name;
        return fileName !== deleteName;
      })
    );

    onRemove(fileToDelete); // This calls the API
    setShowDeleteModal(false);
    setFileToDelete(null);
  };

  return (
    <div className="flex flex-col w-full gap-2">
      <div className="w-full relative space-y-1">
        {label && (
          <div
            className={classNames(
              "text-xs font-medium text-text-disabled mb-1 font-CanelaDeck",
              labelClasses
            )}
          >
            {label}
          </div>
        )}
        {(isMultiple || files.length === 0) && (
          <div className="h-80 w-full relative border-2 items-center rounded-md cursor-pointer border-text-secondary/50 border-dashed">
            <input
              type="file"
              onChange={handleFileChange}
              className="h-full w-full opacity-0 z-[1] absolute cursor-pointer"
              multiple={isMultiple}
              name="files[]"
              accept={formats}
            />
            <div className="h-full w-full absolute z-1 flex justify-center items-center top-0">
              <div className="flex flex-col space-y-1 text-center">
                <div className="text-primary text-3xl bg-primary/10 w-14 h-14 flex items-center justify-center rounded-md mx-auto">
                  <i className="fa-thin fa-cloud-arrow-up"></i>
                </div>
                <div className="text-lg font-bold text-deep-purple">
                  {title}
                </div>
                <div className="text-sm text-slate-400 font-medium">
                  Supported formats: {formats}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {message && (
        <div className="text-xs text-red-600 text-center">{message}</div>
      )}

      {files.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {files.map((file, index) => {
            const fileURL = getFileURL(file);
            const fileType = getFileType(file);

            return (
              <div
                key={index}
                className={classNames(
                  "relative w-20 h-20 rounded-md border border-opplio-border flex group",
                  previewClasses
                )}
              >
                {removeButton && (
                  <div className="opacity-0 invisible transition-all duration-200 group-hover:opacity-100 group-hover:visible">
                    <Button
                      buttonIcon={"fa-light fa-xmark"}
                      buttonIconPosition={"left"}
                      buttonClasses={
                        "!absolute !w-5 !h-5 !p-0 !justify-center -top-1 -right-1 !text-xs !bg-primary !border-none"
                      }
                      // buttonFunction={() => removeFile(file)}
                      buttonFunction={() => {
                        setFileToDelete(file);
                        setShowDeleteModal(true);
                      }}
                    />
                  </div>
                )}
                <div className="w-full h-full overflow-hidden rounded-md">
                  {fileType === "image" ? (
                    <img
                      src={fileURL}
                      alt="preview"
                      className="h-full w-full object-cover"
                    />
                  ) : fileType === "video" ? (
                    <video
                      src={fileURL}
                      controls
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <iframe
                      title={`file-${index}`}
                      className="h-full w-full object-cover"
                      src={fileURL}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      <DeleteModal
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setFileToDelete(null);
        }}
        deleteHandler={confirmDelete}
        customMessage={"Are you sure you want to delete this file?"}
      />
    </div>
  );
};

export default DragDropfile;
